import { AVAILABLE, COMING_SOON, ENTRY_CLOSED, SOLD_OUT } from './availabilityTypes';

/**
 * Retuns an object summarising ticket availability given a races array.
 * Optionally takes a filter to apply to each tickets array.
 */
export default (races = [], filter = n => n) => {
  const availabilityTypes = [].concat(
    ...races.filter(r => !!r.tickets).map(r => r.tickets.tickets.filter(filter).map(t => t.availability.type)),
  );

  // "Available" if any tickets are available
  if (availabilityTypes.includes(AVAILABLE)) {
    return { type: AVAILABLE };

  // Otherwise "Coming Soon" if any are coming soon
  } else if (availabilityTypes.includes(COMING_SOON)) {
    return { type: COMING_SOON };

  // "Sold out" if any others are sold out
  } else if (availabilityTypes.filter(t => t === SOLD_OUT).length > 0) {
    return { type: SOLD_OUT };
  }

  // "Entry closed" in other cases, "Not available" or partially "Sold out" are overlooked
  return { type: ENTRY_CLOSED };
};



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/helpers/getRacesTicketAvailability.js